import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "demand-article-group" };
const _hoisted_2 = { class: "demand-article-group__title" };
import DemandCalendarArticle from "./DemandCalendarArticle.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DemandArticleGroup',
    props: {
        title: {},
        variants: {},
        hoveredVariant: {}
    },
    emits: ['variantHover'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.variants, (variant) => {
                    return (_openBlock(), _createBlock(DemandCalendarArticle, {
                        key: variant.variant.id,
                        variant: variant.variant,
                        onHover: ($event) => (emit('variantHover', variant)),
                        class: _normalizeClass(["demand-article-group__article", { 'demand-article-group__article--hover': variant === __props.hoveredVariant }])
                    }, null, 8, ["variant", "onHover", "class"]));
                }), 128))
            ]));
        };
    }
});
